module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('top-facts')], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('top-breweries')], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('top-drinkers')], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('top-favorites')], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b5df5008", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5df5008"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Facts.vue
// module id = 156
// module chunks = 1